import {
  Accordion,
  DateRangePickerField,
  FieldSet,
  InputWithBlankSearchField,
  InputWithExclusionField,
  TextStringField,
  titleName,
  useItemNames,
} from '@ps-smart-cp/ppfw-client';
import type { ReactNode } from 'react';
import { mstListSearchFieldConfig } from '../item-config';
import type { MstListSearch } from '../models';

interface SearchBasicInfoProps<T extends MstListSearch> {
  mstSearch: T;
  setMstSearch: (t: T) => void;
  summary: string;
  onClose?: () => void;
  errorFields?: string[];
  children?: (mstSearch: T, setMstSearch: (t: T) => void, errorFields?: string[]) => ReactNode;
  isInDialog?: boolean;
}

export function SearchBasicInfo<T extends MstListSearch>({
  mstSearch,
  setMstSearch,
  summary,
  onClose,
  errorFields,
  children,
  isInDialog,
}: SearchBasicInfoProps<T>) {
  const getTitleName = useItemNames(titleName);

  return (
    <FieldSet legendProps={{ title: getTitleName('extractCondition'), id: 'extract-condition' }}>
      <Accordion summary={summary} title={getTitleName('basicInfo')} onClose={onClose}>
        <InputWithExclusionField
          items={mstListSearchFieldConfig}
          obj={mstSearch}
          setObj={setMstSearch}
          prop="codeRange"
          errorFields={errorFields}
          innerComponentStyle={isInDialog ? { maxWidth: '286px' } : undefined}
        />
        <TextStringField
          items={mstListSearchFieldConfig}
          prop="name"
          obj={mstSearch}
          setObj={setMstSearch}
          errorFields={errorFields}
        />
        <InputWithBlankSearchField
          items={mstListSearchFieldConfig}
          obj={mstSearch}
          setObj={setMstSearch}
          prop="mstSpareName01Condition"
          errorFields={errorFields}
        />
        <InputWithBlankSearchField
          items={mstListSearchFieldConfig}
          obj={mstSearch}
          setObj={setMstSearch}
          prop="mstSpareName02Condition"
          errorFields={errorFields}
        />
        <DateRangePickerField
          items={mstListSearchFieldConfig}
          obj={mstSearch}
          setObj={setMstSearch}
          prop="validityStartDateCondition"
          componentType="ymd"
          errorFields={errorFields}
        />
        <DateRangePickerField
          items={mstListSearchFieldConfig}
          obj={mstSearch}
          setObj={setMstSearch}
          prop="validityEndDateCondition"
          componentType="ymd"
          errorFields={errorFields}
        />
        <InputWithBlankSearchField
          items={mstListSearchFieldConfig}
          obj={mstSearch}
          setObj={setMstSearch}
          prop="mstNoteCondition"
          errorFields={errorFields}
        />
        {children?.(mstSearch, setMstSearch, errorFields)}
      </Accordion>
    </FieldSet>
  );
}
